import { useEffect, useState } from 'preact/hooks';
import Storefront from 'utils/storefront';
import * as queries from 'utils/storefront/queries';
import { edgesToNodes } from 'utils/storefront/format-resource';

const productBrRecommendations = () => {
  const storefront = Storefront.getInstance();
  const [products, setProducts] = useState([]);
  const recommendationId = window.emailBrRecommendationId;

  const getProducts = async (data) => {
    const ids = data.map(
      (product) => `gid://shopify/Product/${product.product_id}`,
    );

    const response = await storefront.request({
      query: queries.getProductsByIds,
      variables: {
        ids,
      },
    });

    if (!response.data) {
      // eslint-disable-next-line no-console
      console.error(
        'product-br-recommendations Storefront API request failed',
        response,
      );
      return [];
    }

    const existingProducts = response.data.nodes.filter(
      (product) => product != null && product.availableForSale,
    );

    if (!existingProducts.length) {
      return [];
    }

    return edgesToNodes(existingProducts, 'product');
  };

  const onRecommendationsLoaded = (data) => {
    setProducts([]);
    if (data && data.length > 0) {      
      const itemIds = data.map((product) => product.item_id);
      // eslint-disable-next-line no-undef      
      exponea.track('recommendation', {
        action: 'show',
        item_ids: itemIds, 
        recommendation_id: recommendationId,
        placement: 'oce',
      });
      // eslint-disable-next-line no-shadow
      getProducts(data).then((items) => setProducts(items));
    }
  };

  useEffect(() => {
 
    if (recommendationId?.length > 0) { 
          const options = {
            recommendationId,
            size: 10,
            callback: onRecommendationsLoaded,
            fillWithRandom: true,
          };
          // call recommedations
          // eslint-disable-next-line no-undef
          exponea.getRecommendation(options);
    }

  }, []);


  if (!products.length) return null;
  const recData = [];
  const handleString = products.slice(0, 4).map(product => product.handle).join(',');
  recData.push(handleString);
  const imgString = products.slice(0, 4).map(product => product.images?.[0]?.src).join(',');
  recData.push(imgString);
  return recData;
};

export default productBrRecommendations;
